export enum ERuntimeSettings {
  /** Манифест виджета авторизации **/
  loginWidgetManifest = 'loginWidgetB2CManifest',
  /** Манифест виджета калькулятора **/
  offerCalculatorManifest = 'offerCalculatorManifest',
  /** Дефолтный стейт калькулятора **/
  calculatorInitialValues = 'mortgage-promo-frontend.calculatorInitialValues',

  /* PLATFORM */
  projectName = 'projectName',
  initialState = 'initialState',
  applicationContextCustom = 'applicationContext.custom',
  soprApiBaseUrl = 'soprApi.browserUrl',
  isWebView = 'web.isWebView',
}
